module.exports = __webpack_public_path__ + "static/media/EiffageIcon.09b0ef68.jpg";